// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5wFR-","col":"styles_col__2d89x","actions":"styles_actions__3yb2i","conflict":"styles_conflict__3XrAz"};